<div class="container min-vh-100 d-flex align-items-center justify-content-center">
  <div class="card register-card shadow-lg border-0 w-100" style="max-width: 520px;">
    <div class="card-body p-5">

      <!-- Header -->
      <div class="text-center mb-4">
        <h2 class="fw-bold brand-title">Create Your Account</h2>
        <p class="text-muted">
          Tenant registration for RCI Rentals
        </p>
      </div>

      <form (ngSubmit)="register()" #registerForm="ngForm" novalidate>

        <!-- Name -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label">First Name</label>
            <input
              type="text"
              class="form-control"
              name="firstName"
              [(ngModel)]="firstName"
              required />
          </div>

          <div class="col-md-6">
            <label class="form-label">Last Name</label>
            <input
              type="text"
              class="form-control"
              name="lastName"
              [(ngModel)]="lastName"
              required />
          </div>
        </div>

        <!-- Email -->
        <div class="mb-3">
          <label class="form-label">Email Address</label>
          <input
            type="email"
            class="form-control"
            name="email"
            [(ngModel)]="email"
            required />
        </div>

        <!-- Password -->
        <div class="mb-3" *ngIf="!isGoogleSignup" class="form-group">
          <label class="form-label">Password</label>
          <input
            type="password"
            class="form-control"
            name="password"
            [(ngModel)]="password"
            required />
        </div>
        <!-- Phone -->
        <div class="mb-3">
          <label class="form-label">
            Phone <span class="text-muted">(optional)</span>
          </label>
          <input
            type="tel"
            class="form-control"
            name="phone"
            [(ngModel)]="phone" />
        </div>

        <!-- Rental Selection -->
  <div class="mb-4">
    <label class="form-label">Current Tenant?</label>
    <label class="form-label">Select Your Current Address</label>

    <select
      class="form-select"
      [(ngModel)]="selectedRentalId"
      name="rentalId"
      required
    >
      <option value="" disabled selected>
        Choose a rental
      </option>
      <option value="none">Not currently a tenant</option>
      <option
        *ngFor="let rental of rentals$ | async"
        [value]="rental.id"
      >
        {{ rental.address }}
      </option>
    </select>

    <small class="text-muted d-block mt-1">
      Only currently available rentals are shown
    </small>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>


        <!-- Submit -->
        <button
          type="submit"
          class="btn btn-brand w-100 py-2"
          [disabled]="registerForm.invalid">
          Create Account
        </button>

      </form>

    </div>
  </div>
</div>
